import { useQuery } from '@tanstack/react-query';
import type { CustomerOriginResponse } from '@repo/schemas';
import { fetcher } from '@dashboard/services/request';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { customerOriginKey } from '@dashboard/lib/queryKeys';

export function useCustomerOrigin(customer: { _id: string; seller: string }) {
  const { token } = useAuth();

  return useQuery<CustomerOriginResponse>({
    queryKey: customerOriginKey(customer._id),
    queryFn: () => fetcher(`/sellers/${customer.seller}/customers/${customer._id}/origin`, token),
    staleTime: 60_000,
  });
}
